// constants/planLimits.js - Safe Premium Pricing Structure

export const PLAN_LIMITS = {
  free: {
    name: 'Free',
    price: 0,
    productId: null, // Free plan has no product ID
    monthlyProjects: {
      prompt: 3,
      audio: 2,
      total: 5
    },
    maxAudioDuration: 600,   // 10 minutes
    mp4Downloads: 5,
    features: [
      '3 Prompt-Based Projects per Month',
      '2 Audio-Based Projects per Month',
      'Maximum 10-Minute Upload Length',
      '5 Premium HD Video Downloads (1080p)',
      'Automated Audio-Video Synchronization',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports'
    ],
    exportFormats: ['png', 'pptx'],
    popular: false
  },

  starter: {
    name: 'Starter',
    price: 12.99,
    productId: 'pdt_0NXbbMdrJyd2bJ3MJPtLN', // TODO: Add Dodo product ID when created
    monthlyProjects: {
      prompt: 60,
      audio: 10,
      total: 70
    },
    maxAudioDuration: 600,  // 10 minutes
    mp4Downloads: 20,
    features: [
      '60 Prompt-Based Projects per Month',
      '10 Audio-Based Projects per Month',
      'Maximum 10-Minute Upload Length',
      '20 Premium HD Video Downloads (1080p)',
      'Automated Audio-Video Synchronization',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports',
      'All Export Formats Included'
    ],
    exportFormats: ['png', 'pptx', 'mp4'],
    popular: false
  },

  creator: {
    name: 'Creator',
    price: 29.99,
    productId: 'pdt_0NXbbUv7zf6O8xt6pOcbw', // ✅ Dodo product ID
    monthlyProjects: {
      prompt: 150,
      audio: 50,
      total: 200
    },
    maxAudioDuration: 2400,  // 40 minutes
    mp4Downloads: 80,
    features: [
      '150 Prompt-Based Projects per Month',
      '50 Audio-Based Projects per Month',
      'Maximum 40-Minute Upload Length',
      '80 Premium HD Video Downloads (1080p)',
      'Automated Audio-Video Synchronization',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports',
      'Priority Rendering Queue',
      'All Export Formats Included'
    ],
    exportFormats: ['png', 'pptx', 'mp4'],
    popular: true
  },

  professional: {
    name: 'Professional',
    price: 59.99,
    productId: 'pdt_0NXbbaSvaRyhUyW8u1BFT', // ✅ Dodo product ID
    monthlyProjects: {
      prompt: 250,
      audio: 100,
      total: 350
    },
    maxAudioDuration: 3600,  // 60 minutes
    mp4Downloads: 150,
    features: [
      '250 Prompt-Based Projects per Month',
      '100 Audio-Based Projects per Month',
      'Maximum 60-Minute Upload Length',
      '150 Premium HD Video Downloads (1080p)',
      'Automated Audio-Video Synchronization',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports',
      'Priority Support',
      'Priority Rendering Queue',
      'All Export Formats Included'
    ],
    exportFormats: ['png', 'pptx', 'mp4'],
    popular: false
  }
};

// ============================================
// UTILITY FUNCTIONS
// ============================================

export const getPlanLimits = (planType) => {
  const normalizedPlan = planType?.toLowerCase() || 'free';
  return PLAN_LIMITS[normalizedPlan] || PLAN_LIMITS.free;
};

export const planAllowsExport = (planType, feature) => {
  const plan = getPlanLimits(planType);
  return plan.exportFormats.includes(feature.toLowerCase());
};

export const getMaxAudioDuration = (planType) => {
  const plan = getPlanLimits(planType);
  return plan.maxAudioDuration;
};

export const formatDuration = (seconds) => {
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min`;
  return `${Math.floor(seconds / 3600)} hour${seconds / 3600 > 1 ? 's' : ''}`;
};

export const getAllPlanTypes = () => {
  return Object.keys(PLAN_LIMITS);
};

// Get product ID for a specific plan (useful for checkout)
export const getProductId = (planType) => {
  const plan = getPlanLimits(planType);
  return plan.productId;
};

// Check if a plan has a valid product ID
export const isPlanPurchasable = (planType) => {
  const plan = getPlanLimits(planType);
  return Boolean(plan.productId);
};

export default PLAN_LIMITS;